import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/styles.css';
import '../styles/NotFound.css';
import notFoundImg from '../assets/404.gif';

const NotFound = () => {
  return (
    <div className="container">
      <div className="page-content">
        <div className="about-hero">
          <p className="about-eyebrow">Error 404</p>
          <h1 className="about-headline">Page not found.</h1>
        </div>
        <div className="about-body">
          <div className="about-section">
            <img src={notFoundImg} alt="404" className="not-found-image" />
            <p>This page doesn't exist or may have been moved.</p>
          </div>
          <div className="about-cta">
            <Link to="/">← Back to collections</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
